// Mappings from team type to blueprint key
export enum Team {
	ProductManagement = 'Product management',
	Marketing = 'Marketing',
	Design = 'Design',
	ProjectManagement = 'Project management',
	Operations = 'Operations',
	ITSupport = 'IT support',
	Finance = 'Finance',
	HumanResources = 'Human resources',
	Legal = 'Legal',
	Sales = 'Sales',
	SoftwareDevelopment = 'Software development',
	Default = 'default',
}

export const TEAM_TYPE_BLUEPRINT_MAPPING: Record<Team, string> = {
	[Team.ProductManagement]:
		'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
	[Team.Marketing]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
	[Team.Design]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
	[Team.ProjectManagement]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
	[Team.Operations]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
	[Team.ITSupport]:
		'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
	[Team.Finance]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
	[Team.HumanResources]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
	[Team.Legal]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
	[Team.Sales]:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
	[Team.SoftwareDevelopment]: 'flowchart',
	[Team.Default]: '',
};
